import { render } from "./KappKontakte.vue?vue&type=template&id=6db037e9&scoped=true"
import script from "./KappKontakte.vue?vue&type=script&lang=js"
export * from "./KappKontakte.vue?vue&type=script&lang=js"

import "./KappKontakte.vue?vue&type=style&index=0&id=6db037e9&scoped=true&lang=css"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db037e9"]])

export default __exports__